import React, { forwardRef, useMemo, useRef } from 'react';
import { AnimatePresence } from 'framer-motion';
import { createTransition, MotionEasings, } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import { useButtonMotion } from '@polestar/component-warehouse-react/components/button/internal/buttonMotion';
import { animatedIconContainerStyling, AnimatedIconInner, AnimatedIconWrapper, } from '@polestar/component-warehouse-react/tokens/icons/Icons.helpers';
import { useDirection } from '@polestar/component-warehouse-react/contexts/direction';
const makeAnimatedArrowLeft = (Component) => {
    const AnimatedArrowLeft = forwardRef(() => {
        const { hover } = useButtonMotion();
        const hoverCounter = useRef(0);
        useMemo(() => {
            if (hover) {
                hoverCounter.current++;
            }
        }, [hover]);
        const { isRTL } = useDirection();
        // not text-pairing so do not use 1em, but 2em for animation translation
        return (React.createElement(AnimatedIconWrapper, null,
            React.createElement(AnimatePresence, null,
                React.createElement(AnimatedIconInner, { key: hoverCounter.current, initial: hoverCounter.current === 0
                        ? false
                        : {
                            opacity: 0,
                            transform: `translateX(${isRTL ? '-' : ''}2em)`,
                        }, animate: {
                        opacity: 1,
                        transform: 'translateX(0em)',
                    }, exit: {
                        opacity: 0,
                        pointerEvents: 'none',
                        transform: `translateX(${isRTL ? '' : '-'}2em)`,
                    }, transition: createTransition({
                        duration: 0.6,
                        ease: MotionEasings.easeInOutSoft,
                    }) },
                    React.createElement(Component, { style: animatedIconContainerStyling })))));
    });
    AnimatedArrowLeft.displayName = 'AnimatedArrowLeft';
    return AnimatedArrowLeft;
};
export default makeAnimatedArrowLeft;
